import { StoreGroupDTO, StoreGroupMemberDTO } from "./StoreGroupDTO";
import { ReadStoreGroup } from "@/types/storeGroup";
import { ReadStoreGroupMember } from "@/types/storeGroupMember";

/**
 * Mapper functions for StoreGroup DTOs
 *
 * NOTE: In this implementation, DTOs are re-exports of domain schemas.
 * The mapper layer provides type safety and documentation that the
 * DTO layer is part of the domain model contract, not a separate layer.
 *
 * If the backend changes response structure in the future, this mapper
 * becomes the transformation layer.
 */

/**
 * Maps StoreGroupDTO to domain ReadStoreGroup
 * Currently a pass-through since DTO = domain type
 */
export function mapStoreGroup(dto: StoreGroupDTO): ReadStoreGroup {
  return dto as ReadStoreGroup;
}

/**
 * Maps array of StoreGroupDTOs to domain models
 */
export function mapStoreGroups(dtos: StoreGroupDTO[]): ReadStoreGroup[] {
  return dtos.map(mapStoreGroup);
}

/**
 * Maps StoreGroupMemberDTO to domain model
 */
export function mapStoreGroupMember(
  dto: StoreGroupMemberDTO,
): ReadStoreGroupMember {
  return dto as ReadStoreGroupMember;
}

/**
 * Maps array of StoreGroupMemberDTOs to domain models
 */
export function mapStoreGroupMembers(
  dtos: StoreGroupMemberDTO[],
): ReadStoreGroupMember[] {
  return dtos.map(mapStoreGroupMember);
}
